export default __webpack_public_path__ + "static/multiple-pipelines-switching-pipelines-kanban-777893c08fbef68e242ac83596f2a6d8.mp4";